import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { PageType } from '../enums/page-type.enum';
import { PageModel } from '../model/page.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
    providedIn: 'root'
})
export class PagesService extends BaseFucntionsService<PageModel> {

    constructor(apiClient: ApiClientService) {
        super(ApplicationRoutes.Page.Pages, apiClient);
    }

    getPage(type: PageType, id: number = null) {
        return this.apiClient.get(ApplicationRoutes.Page.PageType(type)+ (id ? `?id=${id}` : ''));
    }

    getPages() {
        return this.apiClient.get(ApplicationRoutes.Page.Pages);
    }
}
